import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Api } from '../../../services/api';

@Component({
  selector: 'app-nav-contact-functions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nav-contact-functions.html',
  styleUrls: ['./nav-contact-functions.css']
})
export class NavContactFunctions {
  public oportunidad_id: string = '';
  public api = inject(Api);
  public contactos: any = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
      this.route.params.subscribe(params => {
      this.oportunidad_id = params['id'];
      console.log(this.oportunidad_id);

      this.getContactFunctions(this.oportunidad_id);
    });
  }

  navigateToFullTable() {
    this.router.navigate(['/contact-functions/'+this.oportunidad_id]); 
  }

  getContactFunctions(oportunidad_id: string){
    this.api.getContactFunctions({oportunidad_id:oportunidad_id}).subscribe({
      next: (data:any)=>{
        this.contactos = data.contactos;
      }, 
      error: (err:any)=>{
        console.error(err);
      }
    })
  }
}